import { mapGetters,mapMutations } from 'vuex';
import { orderService } from '../../services/OrderService'

export default {
    name: 'Offer',
    components: {

    },

    props:
    {
        orderId: {
            type: Number
        },
        period: {
            type: Number
        },
        offer: {},
        company: '',
        orderCachekey: '',
        showExtraOffers: {
            type: Boolean
        },
        showFriendlyErrors: {
            type: Boolean
        },
        showDirectSettlementPrice: {
            type: Boolean
        },
        showErrorsAtEnd: {
            type: Boolean
        }
    },

    data: () => {
        return {
            loading: true,
            mutableOffer: {},
            formatter: new Intl.NumberFormat('ro-RO', {
                style: 'currency',
                currency: 'RON',
            }),
            selectedOffer: 'RCA',
        }
    },

    created() {

        this.mutableOffer = this.offer;
        this.getOffer();
    },
    computed: {

        ...mapGetters({
            // general
            typeSettings: "general/typeSettings",

            // order
            order: "order/order",
            
        }),

        id: function () {
            return this.company + this.period;
        }

    },
    methods: {
        ...mapMutations({
            setSelectedOffer: 'order/setSelectedOffer',
        }),

        //


        //
        getOffer: function () {
            var model = this;
            this.loading = true;
            model.$emit('offerRequested', this.company)
            orderService.getOffer(this.orderId, this.company,
                this.period, this.orderCachekey,
                this.showExtraOffers, this.showDirectSettlementPrice).then(response => {

                    model.mutableOffer = response.data;
                    // in caz de eroare punem un pret foarte mare 
                    if (model.mutableOffer.HasErrors && model.showErrorsAtEnd) {
                        model.mutableOffer.Price = 99999;
                    }

                    model.calculateTotalOffer();
                    model.$emit('offerReceived', model.mutableOffer)

                    this.loading = false;
                })
        },

        calculateTotalOffer() {

            if (this.offer == null)
                return 0;
            var total = 0;
            if (this.selectedOffer === 'RCA') {
                this.offer.DirectSettlement = false;
                total = this.offer.Price;
            }
            else {
                this.offer.DirectSettlement = true;
                total = this.offer.DirectSettlementPrice;
            }
            if (this.offer.ExtraOffers != null) {
                this.offer.ExtraOffers.forEach(extraOffer => {
                    if (extraOffer.Selected) {
                        total += extraOffer.Value;
                    }
                });
            }
            return total.toFixed(2);

        },
        //
        extraOffersChanged: function (checked, extra) {
            this.$nextTick(() => {
                // this.calculateTotalOffer();
            });
        },

        //
        selectOfferClick: function () {
            //this.setSelectedOffer(this.offer);
            this.$emit('offerSelected', this.offer);
        }
    },
}
